<script>


	//svelte native
	import { onMount } from 'svelte';
	//Components
	import ComponentIntroText from "../components/ComponentIntroText.svelte";
	import ComponentIntroTextWithCTA from "../components/ComponentIntroTextWithCTA.svelte";
	import ComponentLatestMaps from "../components/ComponentLatestMaps.svelte";
	import ComponentMapList from "../components/ComponentMapList.svelte";
	import ComponentMapThumb from "../components/ComponentMapThumb.svelte";
	import ComponentParaOne from "../components/ComponentParaOne.svelte";
	import ComponentPlainTextWithCTALarge from "../components/ComponentPlainTextWithCTALarge.svelte";
	import ComponentPlainTextWithCTASmall from "../components/ComponentPlainTextWithCTASmall.svelte";
	import ComponentPlainTextWithImage from "../components/ComponentPlainTextWithImage.svelte";
	import ComponentPlainTextWithPromo from "../components/ComponentPlainTextWithPromo.svelte";
	import ComponentQuote from "../components/ComponentQuote.svelte";
	import ComponetListSearch from "../components/ComponentListSearch.svelte";
	import ComponentBannerFour from "../components/ComponentBannerFour.svelte";
	import ComponentFeatureOne from "../components/ComponentFeatureOne.svelte";
	import ComponentFeatureThree from "../components/ComponentFeatureThree.svelte";

	// Modules
	import {fetchPageData} from "../modules/fetchPageData.js";
	import {selectWhere} from "../modules/selectWhere.js";
	import {selectEach} from "../modules/selectWhere.js";
	import {ficDeMenu} from "../modules/ficMenu.js";

		const comps = [
		{"ComponentIntroText" : ComponentIntroText },
		{"ComponentIntroTextWithCTA" :ComponentIntroTextWithCTA},
		{"ComponentLatestMaps": ComponentLatestMaps},
		{"ComponentMapList": ComponentMapList},
		{"ComponentMapThumb": ComponentMapThumb},
		{"ComponentParaOne": ComponentParaOne },
		{"ComponentPlainTextWithCTALarge": ComponentPlainTextWithCTALarge},
		{"ComponentPlainTextWithCTASmall": ComponentPlainTextWithCTASmall},
		{"ComponentPlainTextWithImage": ComponentPlainTextWithImage},
		{"ComponentPlainTextWithPromo": ComponentPlainTextWithPromo},
		{"ComponentQuote--bp": ComponentQuote},
		{"ComponentListSearch": ComponetListSearch},
		{"ComponentBannerFour": ComponentBannerFour},
		{"ComponentFeatureOne": ComponentFeatureOne},
		{"ComponentFeatureThree": ComponentFeatureThree},
	];

	let elements = [];


	let pageContent;

	//
	//Quick body tag hack
	let outBod = document.getElementById("outerBody");
	outBod.classList.add("default");
	outBod.classList.remove("map");
	//
	// end  hack :)
	//

	onMount(async  () =>{
	    pageContent = await fetchPageData("page-elements","All community maps");
	     // console.log("pageContent",pageContent);
	     pageContent.forEach(element => elements.push(element));

	    // sort the array on  locationonpage
	    elements.sort(function(a, b) {
	  		var keyA = a.locationOnPage,
	    	keyB = b.locationOnPage;
	  // Compare the 2 
	  		if (keyA < keyB) return -1;
	  		if (keyA > keyB) return 1;
	  		return 0;
		});
		ficDeMenu();
	});
</script>
<div>
	{#if pageContent}
	{#each elements as body}
		{#each comps as comp}
		
				{#if  comp.hasOwnProperty( body.svelte_component.sveltename) }
				<!-- {console.log("body: ", body)} -->

					<svelte:component 
					this = { comp[body.svelte_component.sveltename] } 
					pageCopy={body.Copy}  
					pageTitle={body.Title}  
					buttonLink={body.ButtonLink} 
					buttonText={body.ButtonLabel}
					pageImage={body.Image}
					
					/>
				{:else}
				{/if}

			{/each}
			{/each}
	{:else  }	
	...
	{/if}
</div>

